import { Dispatch, MutableRefObject, SetStateAction } from "react";
import LazySelect from "../../../../../Components/CardsPages/Forms/LazySelect";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import { ListarMotivoCancelamentoController } from "../../../../../Controllers/Geral/GestaoDeCadastros/MotivoCancelamento/MotivoCancelamentoController";
import {
    IAtendimentoClienteRequest,
    TModoGestaoAtendimento,
} from "../../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import Select from "react-select";
import SelectCategoriaAtendimento from "../../../../../Components/CardsPages/Forms/SelectCategoriaAtendimento";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { FormProvider, useForm } from "react-hook-form";
import { useUserInfor } from "../../../../../Context/User";
import { CanalAtendimentoInterface } from "../../../../../Interfaces/Geral/GestaoDeCadastro/TipoCanalAtendimento/CanalAtendimentoInterfaces";
import { UsuarioInterface } from "../../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";

interface IFilterFormDataInterface {
    DT_INICIAL_IN?: string;
    DT_INICIAL_FN?: string;
    DT_EXPECTATIVA_CONCLUSAO_IN?: string;
    DT_EXPECTATIVA_CONCLUSAO_FN?: string;
    DT_SLA_IN?: string;
    DT_SLA_FN?: string;
    DT_ULTIMA_INTERACAO_IN?: string;
    DT_ULTIMA_INTERACAO_FN?: string;
    DT_FINAL_IN?: string;
    DT_FINAL_FN?: string;
    ORDER_BY?: string;
    VL_DESC_ASC?: string;
    DT_REAL_CONCLUSAO?: string;
    DS_STATUS_CASO?: string;
    ID_MOTIVO_CANCELAMENTO?: number;
    ID_EMPREENDIMENTO?: string | number;
    ID_UNIDADE?: number;
    ID_CASO?: number;
    FL_ANDAMENTO?: number;
    FL_CONTEM?: boolean;
    PESQUISA?: string;
    ID_USUARIO?: number;
    DS_NOME_CONTA?: string;
    DS_NOME_CONTATO?: string;
    ID_CATEGORIA_ATENDIMENTO?: number[];
    ID_SUBCATEGORIA?: number;
    ID_CONTA: number;
    ID_ACOMPANHAMENTO?: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO?: string[] /* array de arrays 'stringados' - ['8', '12,15,37', '38, 99'] */;
    ID_TIPOS_PESOS_ATENDIMENTOS?: number[];
    ID_TIPO_CANAL_ATENDIMENTO?: 0;
}

interface Option {
    label: string;
    value: number;
}

interface IFiltroAtendimentos {
    atendimento: TModoGestaoAtendimento;
    filter: IAtendimentoClienteRequest | undefined;
    FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE: string | null;
    // filtroGestaoStorage: StorageManagerCapys<IAtendimentoClienteRequest>;

    watchStatusCaso: string | undefined;
    limparFiltros: () => void;
    setIdEmpreendimento: Dispatch<SetStateAction<string | number[]>>;
    setIdTipoPeso: (id: number[]) => void;
    categoriaAtendimento: number[] | undefined;
    setCategoriaAtendimento: (id: number[]) => void;
    options: any;
    valueEtapa:
        | {
              label: string;
              value: number;
          }[]
        | null;
    setValueEtapa: Dispatch<
        SetStateAction<
            | {
                  label: string;
                  value: number;
              }[]
            | null
        >
    >;
    valueSubCategoria:
        | {
              label: string;
              value: number;
          }[]
        | null;
    setValueSubCategoria: Dispatch<
        SetStateAction<
            | {
                  label: string;
                  value: number;
              }[]
            | null
        >
    >;
    selectInputRef: MutableRefObject<any>;
    tipoRef: MutableRefObject<any>;
    customStyles: {
        control: (base: any) => any;
    };
    subCategoriasOptions:
        | {
              label: string;
              value: number;
          }[]
        | undefined;
    tipoAtendimento: TModoGestaoAtendimento;
    etapasOptions:
        | {
              label: string;
              value: number;
          }[]
        | undefined;
    lstTipoPesoOptions:
        | {
              label: string;
              value: number;
          }[]
        | undefined;
    listarCanalAtendimento: () => Promise<CanalAtendimentoInterface[]>;
    filtroInicial: any;
    valueEmpreendimentos: Option[];
    setValueEmpreendimentos: Dispatch<SetStateAction<Option[]>>;
    setPage: (page: number) => void;
    lstUsuarios: UsuarioInterface[] | undefined;
    handleDateChange: (formData: IFilterFormDataInterface) => void;
    valueAtendente: {
        label: string;
        value: number;
    } | null;
    atendentesOptions:
        | {
              label: string;
              value: number;
          }[]
        | undefined;
    setValueAtendente: Dispatch<
        SetStateAction<{
            label: string;
            value: number;
        } | null>
    >;
}

export default function FiltroAtendimentos(props: IFiltroAtendimentos) {
    const { id } = useModuloInfo();

    const { UserInfor } = useUserInfor();
    const FormMethods = useForm<IFilterFormDataInterface>();
    const { register, handleSubmit, reset, setValue, control } = FormMethods;

    const {
        watchStatusCaso,
        limparFiltros,
        setIdEmpreendimento,
        setIdTipoPeso,
        categoriaAtendimento,
        setCategoriaAtendimento,
        options,
        valueEtapa,
        setValueEtapa,
        valueSubCategoria,
        setValueSubCategoria,
        valueAtendente,
        setValueAtendente,
        atendentesOptions,
        selectInputRef,
        tipoRef,
        customStyles,
        subCategoriasOptions,
        tipoAtendimento,
        etapasOptions,
        lstTipoPesoOptions,
        listarCanalAtendimento,
        filtroInicial,
        valueEmpreendimentos,
        setValueEmpreendimentos,
        filter,
        handleDateChange,
    } = props;

    const {
        value: lstMotivoCancelamento,
        loading: lstMotivoCancelamentoLoading,
    } = useAsyncEffect(async () => {
        if (id) return ListarMotivoCancelamentoController(id, "");
    }, [id]);

    return (
        <StickyToolbar active={!!props.FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE}>
            <OrSpinner loading={lstMotivoCancelamentoLoading} spinner="capys">
                <FormProvider {...FormMethods}>
                    <form
                        className="form-group row"
                        onSubmit={handleSubmit(handleDateChange)}
                    >
                        <div className="col-12 mt-3">
                            <label>Data Inicial</label>
                            <div className="row">
                                <div className="col-6">
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_INICIAL_IN}
                                        name="DT_INICIAL_IN"
                                        ref={register()}
                                    />
                                </div>
                                <div className="col-6">
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_INICIAL_FN}
                                        name="DT_INICIAL_FN"
                                        ref={register()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final</label>
                            <div className="row">
                                <div className="col-6 mt-auto">
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_FINAL_IN}
                                        name="DT_FINAL_IN"
                                        ref={register()}
                                    />
                                </div>
                                <div className="col-6 mt-auto">
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_FINAL_FN}
                                        name="DT_FINAL_FN"
                                        ref={register()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="row">
                                <div className="col-6 mt-auto">
                                    <label>
                                        Expectativa de Conclusão Inicial
                                    </label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={
                                            filter?.DT_EXPECTATIVA_CONCLUSAO_IN
                                        }
                                        name="DT_EXPECTATIVA_CONCLUSAO_IN"
                                        ref={register()}
                                    />
                                </div>
                                <div className="col-6 mt-auto">
                                    <label>
                                        Expectativa de Conclusão Final
                                    </label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={
                                            filter?.DT_EXPECTATIVA_CONCLUSAO_FN
                                        }
                                        name="DT_EXPECTATIVA_CONCLUSAO_FN"
                                        ref={register()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="row">
                                <div className="col-6 mt-auto">
                                    <label>Última Interação Inicial</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={
                                            filter?.DT_ULTIMA_INTERACAO_IN
                                        }
                                        name="DT_ULTIMA_INTERACAO_IN"
                                        ref={register()}
                                    />
                                </div>
                                <div className="col-6 mt-auto">
                                    <label>Última Interação Final</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={
                                            filter?.DT_ULTIMA_INTERACAO_FN
                                        }
                                        name="DT_ULTIMA_INTERACAO_FN"
                                        ref={register()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="row">
                                <div className="col-6 mt-auto">
                                    <label>Dt. SLA Inicial</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_SLA_IN}
                                        name="DT_SLA_IN"
                                        ref={register()}
                                    />{" "}
                                </div>
                                <div className="col-6 mt-auto">
                                    <label>Dt. SLA Final</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        defaultValue={filter?.DT_SLA_FN}
                                        name="DT_SLA_FN"
                                        ref={register()}
                                    />{" "}
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-12 mt-3">
                            <label>Ordenar Por:</label>
                            <select
                                className="form-control"
                                name="ORDER_BY"
                                ref={register()}
                                defaultValue={filter?.ORDER_BY}
                            >
                                <option></option>
                                <option value="Data de início do caso">
                                    Data de início do caso
                                </option>
                                {(watchStatusCaso === "Fechado" ||
                                    watchStatusCaso === "Cancelado") && (
                                    <option value="Data fim do caso">
                                        Data fim do caso
                                    </option>
                                )}
                                <option value="Expectativa de Conclusão">
                                    Expectativa de Conclusão
                                </option>
                                <option value="Dt. SLA">Dt. SLA</option>
                                <option value="Protocolo">Protocolo</option>
                                <option value="Data da última iteração">
                                    Data da última iteração
                                </option>
                            </select>
                        </div> */}
                        <div className="col-12 mt-3">
                            <label>Status do Caso</label>
                            <select
                                className="form-control"
                                name="DS_STATUS_CASO"
                                ref={register()}
                                defaultValue={
                                    filter?.DS_STATUS_CASO ?? "Aberto"
                                }
                            >
                                <option></option>
                                <option>Aberto</option>
                                <option>Fechado</option>
                                <option>Cancelado</option>
                            </select>
                        </div>
                        {watchStatusCaso === "Cancelado" && (
                            <div className="col-12 mt-3">
                                <label>Motivo do Cancelamento</label>
                                <select
                                    className="form-control"
                                    name="ID_MOTIVO_CANCELAMENTO"
                                    defaultValue={0}
                                    ref={register()}
                                    // setValue={setValue}
                                >
                                    <option></option>
                                    {lstMotivoCancelamento?.map((motivo) => (
                                        <option
                                            key={motivo.ID_MOTIVO_CANCELAMENTO}
                                            value={
                                                motivo.ID_MOTIVO_CANCELAMENTO
                                            }
                                        >
                                            {motivo.DS_MOTIVO_CANCELAMENTO}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                name="ID_EMPREENDIMENTO"
                                ref={selectInputRef}
                                options={options}
                                isClearable
                                isMulti
                                onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions.map(
                                        (option) => ({
                                            value: option.value,
                                            label: option.label,
                                        })
                                    );
                                    setIdEmpreendimento(
                                        selectedValues.map(
                                            (option) => option.value
                                        )
                                    );
                                    setValueEmpreendimentos(selectedValues);
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                value={valueEmpreendimentos}
                                noOptionsMessage={() => "Nenhuma opção"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Protocolo</label>
                            <input
                                className="form-control"
                                type="number"
                                name="ID_CASO"
                                defaultValue={filter?.ID_CASO}
                                ref={register({
                                    valueAsNumber: true,
                                })}
                            />
                        </div>
                        {props.atendimento === "GRUPO" &&
                            UserInfor.FUNCOES.some(
                                (f) => f.NM_FUNCAO === "ADM_GESTAO_CASO_GRUPO"
                            ) && (
                                <div className="col-12 mt-3">
                                    <label>Situação</label>
                                    <select
                                        className="form-control"
                                        name="FL_ANDAMENTO"
                                        ref={register()}
                                        defaultValue={filter?.FL_ANDAMENTO}
                                    >
                                        <option value={2}>Todos</option>
                                        <option value={1}>
                                            Em Atendimento
                                        </option>
                                        <option value={0}>
                                            Fila de Atendimento
                                        </option>
                                    </select>
                                </div>
                            )}
                        {props.atendimento !== "USUARIO" && (
                            <div className="col-12 mt-3">
                                <label>Atendente</label>
                                <Select
                                    placeholder={""}
                                    noOptionsMessage={() => "Nenhuma opção"}
                                    menuPlacement="auto"
                                    styles={customStyles}
                                    options={atendentesOptions}
                                    value={valueAtendente}
                                    onChange={(e) => {
                                        setValueAtendente(
                                            e as {
                                                label: string;
                                                value: number;
                                            } | null
                                        );
                                    }}
                                    components={{
                                        DropdownIndicator: () => null,
                                        IndicatorSeparator: () => null,
                                    }}
                                    defaultValue={atendentesOptions?.find(
                                        (opt: any) =>
                                            props.filter?.ID_USUARIO ===
                                            opt.value
                                    )}
                                    isClearable
                                />
                            </div>
                        )}
                        <div className="col-12 mt-3">
                            <label>Cliente</label>
                            <input
                                className="form-control"
                                type="text"
                                name="DS_NOME_CONTA"
                                defaultValue={filter?.DS_NOME_CONTA}
                                ref={register()}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Contato</label>
                            <input
                                className="form-control"
                                type="text"
                                name="DS_NOME_CONTATO"
                                ref={register()}
                                defaultValue={filter?.DS_NOME_CONTATO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Categoria de Atendimento</label>
                            <SelectCategoriaAtendimento
                                ID_MODULO={id}
                                setIdCategoria={(c) =>
                                    setCategoriaAtendimento(c as number[])
                                }
                                filterTreeNode={(input, treeNode) =>
                                    treeNode?.props.title
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                                showSearch
                                control={control}
                                defaultValue={categoriaAtendimento}
                                //defaultValue={filter?.current.ID_CATEGORIA_ATENDIMENTO}
                                multiple
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Subcategoria</label>
                            <Select
                                placeholder={""}
                                noOptionsMessage={() => "Nenhuma opção"}
                                menuPlacement="auto"
                                styles={customStyles}
                                options={subCategoriasOptions}
                                value={valueSubCategoria}
                                onChange={(e) =>
                                    setValueSubCategoria(
                                        e as SetStateAction<
                                            | {
                                                  label: string;
                                                  value: number;
                                              }[]
                                            | null
                                        >
                                    )
                                }
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                defaultValue={valueSubCategoria?.filter((opt) =>
                                    Array.isArray(filter?.ID_SUBCATEGORIA)
                                        ? filter?.ID_SUBCATEGORIA.some(
                                              (e) => opt.value === e
                                          )
                                        : filter?.ID_SUBCATEGORIA === opt.value
                                )}
                                isClearable
                                isMulti
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Etapa</label>
                            <Select
                                name="ID_ETAPA_CATEGORIA_ATENDIMENTO"
                                placeholder={""}
                                menuPlacement="auto"
                                noOptionsMessage={() => "Nenhuma opção"}
                                styles={customStyles}
                                options={etapasOptions}
                                value={valueEtapa}
                                onChange={(e) =>
                                    setValueEtapa(
                                        e as SetStateAction<
                                            | {
                                                  label: string;
                                                  value: number;
                                              }[]
                                            | null
                                        >
                                    )
                                }
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                isClearable
                                isMulti
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Peso Atendimento</label>
                            <Select
                                placeholder={""}
                                menuPlacement="auto"
                                ref={tipoRef}
                                onChange={(e) =>
                                    setIdTipoPeso(
                                        e.map((value) => value?.value)
                                    )
                                }
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                options={lstTipoPesoOptions}
                                noOptionsMessage={() => "Nenhuma opção"}
                                isClearable
                                isMulti
                                defaultValue={lstTipoPesoOptions?.filter(
                                    (option) =>
                                        filter?.ID_TIPOS_PESOS_ATENDIMENTOS?.includes(
                                            option.value
                                        )
                                )}
                            />
                        </div>
                        <div className={`col-12 mt-3 `}>
                            <LazySelect
                                className="form-control"
                                label="Canal de Atendimento"
                                name="ID_TIPO_CANAL_ATENDIMENTO"
                                controller={listarCanalAtendimento}
                                getKeyValue={(u) => u.ID_TIPO_CANAL_ATENDIMENTO}
                                getDS={(u) => u.DS_TIPO_CANAL_ATENDIMENTO}
                                defaultValue={filter?.ID_TIPO_CANAL_ATENDIMENTO}
                                ref={register()}
                                setValue={setValue}
                            >
                                <option></option>
                            </LazySelect>
                        </div>
                        {/* <div className={`col-12 mt-3 `}>
                <label>Não contém</label>
                <div className="d-flex justify-content-start">
                    <Switch
                        color="success"
                        labelPosition="top"
                        type="checkbox"
                        name="FL_CONTEM"
                        onChange={(e) => {
                            if (e.target.checked === true) {
                                Swal.fire({
                                    title: "Ao ativar a opção 'Não Contém', sua pesquisa retornará todos os registros que não têm o texto especificado.",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Ok!",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                    },
                                });
                                setNaoContem(false);
                            } else {
                                setNaoContem(true);
                            }
                        }}
                        defaultChecked={false}
                        ref={register()}
                    />
                </div>
            </div> */}
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        `FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE_${tipoAtendimento}`
                                    );
                                    reset(filtroInicial);
                                    limparFiltros();
                                    setValue("ID_USUARIO", 0);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </form>{" "}
                </FormProvider>
            </OrSpinner>
        </StickyToolbar>
    );
}
